<template>
    <v-container style="padding-top: 80px" id="DetallePreAlta">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Detalle Pre Alta de Usuarios</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row justify="center">
                            <v-col cols="12" md="8">
                                <v-row class="mt-2" justify="center" style="display: grid;place-content: center;">
                                    <v-col cols="12" md="12">
                                        <v-avatar size="90">
                                            <v-img src="https://ausa.com.mx/img/Images/perfil.png" alt="Avatar"></v-img>
                                        </v-avatar>
                                    </v-col>
                                </v-row>
                                <vs-list id="texto">
                                    <v-row class="mt-4" justify="center">
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Nombre completo:"
                                                :subtitle="datos.Nombre"></vs-list-item>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Puesto:"
                                                :subtitle="datos.pudescripcion"></vs-list-item>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4" justify="center">
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Teléfono:" :subtitle="datos.pautelefon"></vs-list-item>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Correo:" :subtitle="datos.paucorreo"></vs-list-item>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4" justify="center">
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="RFC:" :subtitle="datos.pauRFC"></vs-list-item>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Fecha de nacimiento: "
                                                :subtitle="datos.paufechaNac"></vs-list-item>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4" justify="center">
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Estado:" :subtitle="datos.esnombre"></vs-list-item>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Localidad:" :subtitle="datos.lonombre"></vs-list-item>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4" justify="center">
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Dirección:" :subtitle="datos.Direccion"></vs-list-item>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Oficina:" :subtitle="datos.ofnombre"></vs-list-item>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4" justify="center">
                                        <v-col cols="12" md="6">
                                            <vs-list-item title="Jefe Directo:" :subtitle="datos.usnom"></vs-list-item>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4 " justify="center">
                                        <v-col cols="12" md="12">
                                            <vs-list-item title="Observaciones:" :subtitle="datos.pauobs">
                                            </vs-list-item>
                                        </v-col>
                                    </v-row>
                                </vs-list>
                                <br>
                                <v-row class="mt-4">
                                    <v-col>
                                        <span class="type-label-style">¿Se autoriza la pre alta? </span>
                                        <div class="text-center">
                                            <v-radio-group v-model="respuesta" row :error-messages="errorRadio"
                                                :disabled="btndisabled">
                                                <v-radio label="SI" value="S"></v-radio>
                                                <v-radio label="NO" value="N"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <span>Observaciones: </span>
                                        <v-textarea outlined v-model="observaciones" :counter="200" maxlength="200"
                                            v-on:blur="observaciones = observaciones != null ? observaciones.trim() : null">
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <label> Firma electrónica: </label>
                                        <v-text-field id="firma" ref="input" v-model="firma" autocomplete="off"
                                            maxlength="16" style="-webkit-text-security: disc;" outlined dense
                                            v-on:blur="firma = firma != '' ? firma.trim() : ''"></v-text-field>
                                        <span v-if="errorFirma" class="mensajeerror">{{
                                            messageFirma
                                        }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                        <v-row justify="center">
                            <v-btn class="ma-2" color="primary" title="Enviar" @click="Enviar()"
                                :disabled="disabledSave">
                                Enviar
                            </v-btn>
                            <v-btn class="ma-2" color="error" title="Regresar" @click="Regresar()"
                                :disabled="disabledSave">
                                Regresar
                            </v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import PreAlta from "@/services/PreAlta/preAlta.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
    },
    data() {
        return {
            showcargando: true,
            permisoPreAlta: false,
            uslogin: '',
            datos: [],
            observaciones: '',
            disabledSave: false,
            firma: '',
            errorFirma: false,
            messageFirma: '',
            respuesta: null,
            errorRadio: '',
            sending: false,
            btndisabled: false,
            pendAutorizacion: 0,
        }
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    watch: {
        'respuesta'(val) {
            if (val != null) {
                this.errorRadio = '';
            }
        },
        'firma'(val) {
            if (val.trim().length < 8) {
                this.messageFirma = 'Firma electrónica no cumple con las características mínimas ';
                this.errorFirma = true;
            } else {
                this.messageFirma = '';
                this.errorFirma = false;
            }
        }
    },
    methods: {
        Regresar() {
            this.$router.push({ name: 'Pre_Alta' }).catch((error) => error);
        },
        async Enviar() {
            this.observaciones = this.observaciones.trim();
            this.errorRadio = this.respuesta == null ? 'Campo requerido' : '';
            this.errorFirma = this.firma == '' ? true : false;
            this.messageFirma = this.firma == '' ? 'Campo requerido' : '';

            if (this.errorRadio == '' && !this.errorFirma) {
                await this.ValidarFirma();
            }
        },
        async ValidarFirma() {
            let val = await PreAlta.valFirmaElectronica(this.firma);
            if (val == 1) {
                this.messageFirma = 'Firma electrónica incorrecta';
                this.errorFirma = true;
            } else {
                this.disabledSave = true;
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true; // Establece la variable de control en true
                this.$swal({
                    title: 'Guardando, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let response = await PreAlta.AutorizarSolicitud(this.datos.pauid, this.observaciones, this.uslogin,
                            this.datos.pauapellidoP, this.datos.pauapellidoM, this.datos.paunombre, this.datos.pudescripcion, this.respuesta, this.pendAutorizacion);
                        if (response) {
                            let mensaje = this.respuesta == 'S' ? 'Se autorizó la pre alta de manera exitosa.' : 'Se rechazó la pre alta de manera exitosa.';
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: mensaje,
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 3000
                            }).then(async () => {
                                this.Regresar();
                            });

                        } else {
                            this.disabledSave = false;
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error al dar respuesta a la pre alta, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 3000
                            })
                        }
                    }
                })
            }
            // Al final del proceso, restablece las variables de control
            this.sending = false;
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '376').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 376)//Permiso para ver las prealtas
                        this.permisoPreAlta = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        this.uslogin = await MetodosGenerales.ObtenerUserName();
        let data = await MetodosGenerales.obtenerSessionReporte('preusr');
        this.datos = await PreAlta.DetalleSolicitud(data.pauid);
        this.btndisabled = this.datos.usloginCreado != "" ? true : false;
        this.respuesta = this.btndisabled == true ? 'S' : null;
        this.pendAutorizacion = this.btndisabled == true ? 1 : 0;
        this.showcargando = false;
    }
}
</script>
<style>
#DetallePreAlta div.vs-list--title {
    color: #6b7280 !important;
}

#DetallePreAlta div.vs-list--subtitle {
    font-size: 20px;
    font-weight: 700;
}

#DetallePreAlta .theme--light.v-card>.v-card__text,
.theme--light.v-card>.v-card__subtitle {
    color: rgba(0, 0, 0, 1);
}

#DetallePreAlta .theme--dark.v-card>.v-card__text,
.theme--dark.v-card>.v-card__subtitle {
    color: rgba(255, 255, 255, 1);
}

.mensajeerror {
    line-height: 12px;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    hyphens: auto;
    color: #FF5C93;
}
</style>

<style lang="scss">
#texto .list-titles {
    overflow-wrap: break-word;
    word-break: break-all;
}
</style>